{
  "aiDetectionPoller": {
    "outsideScheduleStatusText": "Waiting (outside detection hours)",
    "error": "AI detection events couldn't be fetched for all cameras."
  },
  "viewerAiDetectionDialog": {
    "text": "Area not set",
    "text2": "Re-edit on video",
    "text3": "On (set on video)",
    "setErrorMessage": "Detection regions can be set only when one camera is selected.",
    "text4": "Custom detections {{custom}}/{{limit}}",
    "text5": "Preset detections {{template}}/{{limit}}",
    "text6": "Enter a detection title.",
    "text7": "The detection title must be {{MAX_TITLE_LENGTH}} characters or fewer.",
    "text8": "Select target cameras.",
    "text9": "Only cameras with AI detection turned on can be selected.",
    "text10": "No more detections can be added to {{cameraName}}.",
    "text11": "Up to {{customLimit}} custom detections are allowed.",
    "text12": "Enter a detection target.",
    "text13": "Enter a detection condition.",
    "text14": "Up to {{templateLimit}} preset detections are allowed.",
    "text15": "The detection count must be a number of 1 or greater.",
    "text16": "Set an intrusion detection area.",
    "text17": "The intrusion detection area must be at least {{value}}% in both width and height.",
    "text18": "Select a target camera before setting detection regions.",
    "text19": "Up to {{MAX_ROI_COUNT}} detection regions are allowed.",
    "text20": "Each detection region must be at least {{value}}% in both width and height.",
    "text21": "Enter the detection end date and time.",
    "text22": "The detection end date and time must be later than the start date and time.",
    "text23": "The detection end time must be later than the start time.",
    "text24": "Set a detection schedule.",
    "setErrorMessage2": "The area of the target camera couldn't be resolved.",
    "setErrorMessage3": "The tenantCameraId of the target camera couldn't be resolved.",
    "text25": "The detection settings couldn't be saved.",
    "text26": "Edit detection",
    "text27": "Add custom detection",
    "text28": "Loading detection settings",
    "text29": "Updating detection settings",
    "text30": "Saving detection settings",
    "label": "Detection title (up to 10 characters)",
    "label2": "Detection type",
    "menuItem": "People count detection",
    "menuItem2": "No-helmet detection",
    "menuItem3": "Intrusion detection",
    "label3": "Detection count",
    "label4": "Comparison",
    "menuItem4": "Or more",
    "menuItem5": "More than",
    "text31": "Target cameras",
    "alert": "No cameras have AI detection turned on.",
    "alert2": "For intrusion detection, select one target camera and specify the intrusion area on the video.",
    "text32": "Intrusion region",
    "button": "Edit region on video",
    "button2": "Reset",
    "button3": "Clear",
    "text33": "Drag a rectangle on the video to specify a detection region.",
    "text34": "Detection regions",
    "button4": "Off",
    "label5": "Detection start date and time",
    "label6": "Detection end date and time",
    "label7": "No end date",
    "label8": "Detection hours",
    "menuItem6": "All day",
    "menuItem7": "Specify time range",
    "menuItem8": "Specify schedule",
    "label9": "Start time",
    "label10": "End time",
    "button5": "Edit",
    "label11": "Send notification emails",
    "label12": "Notification email recipients",
    "label13": "Notification timing",
    "menuItem9": "Notify on first detection only",
    "menuItem10": "Send an hourly summary",
    "text35": "For cameras with a detection interval of 1 minute or longer, choose first-detection notification or an hourly summary.",
    "text36": "For cameras with a detection interval shorter than 1 minute, notifications are sent on first detection only.",
    "text37": "Detection frequency:",
    "text38": "Loading...",
    "text39": "Updating...",
    "text40": "Running...",
    "text41": "Run"
  },
  "viewerAiResultListItem": {
    "text": "Enlarge AI detection result image",
    "alt": "AI detection result",
    "text2": "people",
    "meterEvent": "Threshold event ({{transition}})",
    "meterReading": "Reading history",
    "rising": "Started",
    "falling": "Cleared",
    "ongoing": "Ongoing"
  },
  "viewerAiRightRail": {
    "label": "Detected at",
    "label2": "Camera",
    "label3": "Detection",
    "label4": "Result",
    "text": "Detection results aren't available for this account.",
    "text2": "Detection results can't be shown for this camera.",
    "title": "Detection condition: {{value}}",
    "text3": "Show on seek bar",
    "text4": "Conditions",
    "text5": "Collapse conditions",
    "text6": "Expand conditions",
    "label5": "Detection target:",
    "label6": "Detection condition:",
    "label7": "Target cameras:",
    "label8": "Period:",
    "text7": "View results in the admin console",
    "text8": "Loading results",
    "text9": "No results yet",
    "text10": "Showing the latest ",
    "text11": " results",
    "imageAlt": "AI detection result",
    "text12": "AI detection result {{previewTimestampLabel}}"
  },
  "viewerAiSettingsMenu": {
    "text": "Detection {{value}}",
    "text2": "No camera set",
    "alert": "AI features in the viewer aren't available for this account.",
    "text3": "AI features are turned off for this camera",
    "text4": "Contact us for details on using this feature.",
    "text5": "* An add-on contract is required to use this feature.",
    "text6": "Detection",
    "text7": "Last detected at:",
    "text8": "Target cameras",
    "text9": "Notification settings",
    "text13": "Detection period",
    "text14": "Detection hours",
    "text15": "Detection frequency",
    "text16": "View results",
    "text17": "Stop",
    "ariaLabel": "AI detection settings",
    "ariaLabel2": "Close AI detection settings",
    "text18": "Loading AI detection information",
    "text19": "Add custom detection",
    "text20": "Active detections (custom ",
    "text21": "No active detections",
    "text22": "Add one with the add button above.",
    "text23": "No active detections are available to view.",
    "text24": "Meter",
    "text25": "Meters can be stopped here. To change settings or resume a stopped meter, contact an administrator. The dedicated processing must be revalidated.",
    "meterReadOnlyGuidance": "To change, stop, or resume meter settings, contact an administrator.",
    "cameraInterval": "Follows the camera's AI settings"
  },
  "viewerRoiEditorOverlay": {
    "button": "Done",
    "alert": "Loading video information",
    "button2": "Confirm",
    "button3": "Add region",
    "text": "Specify at least {{value}}% in both width and height",
    "button4": "Delete selected region",
    "text2": "{{rectLabel}} (unconfirmed)",
    "text3": "Drag on the video to specify a region",
    "text4": "Drag on the video to add a region. Click an existing region to select it, then move or resize it"
  },
  "aiDisabledSupport": {
    "aiDisabledSupportMessage": "AI features are turned off for this camera. Contact us for details on using this feature.",
    "aiUnconfiguredSupportMessage": "This camera has no AI settings. Check the configuration status.",
    "aiDisabledSupportActionLabel": "Contact us about usage",
    "aiDisabledSupportInlineLabel": "How to contact us",
    "aiUnconfiguredSupportLead": "No image detection settings are registered for this camera",
    "aiUnconfiguredSupportFootnote": "* Camera settings must be registered to use image detection."
  },
  "roi": {
    "roiEditorGuideMessage": "Specify a detection region on the video",
    "roiEditorAddGuideMessage": "Drag on the video to draw a new detection region",
    "roiEditorConfirmGuideMessage": "Confirm this region?",
    "roiEditorRectLabel": "Detection region",
    "intrusionRoiEditorRectLabel": "Intrusion detection area",
    "text": "Not set",
    "text2": "{{length}} regions specified"
  },
  "viewerAiPresentation": {
    "text": " / Last checked: {{lastCheckedAt}}",
    "text2": " / Status: {{lastThresholdState}}",
    "text3": "Server detection{{checkedAt}}{{threshold}}",
    "text4": "Helmet detection",
    "text5": "Intrusion detection",
    "text6": "Custom detection",
    "text7": "People count detection",
    "text8": "AI detection",
    "text9": "Not set",
    "text11": "Helmet",
    "text12": "Intrusion",
    "text13": "Custom",
    "text14": "People count",
    "text15": "People: {{peopleCount}}",
    "text16": "Intrusion detection: {{value}}",
    "text17": "LLM detection event",
    "text18": "Intrusion detected ({{value}})",
    "text19": "People count: {{peopleCount}}",
    "text20": "No helmet: {{helmetMissingCount}}",
    "text21": "The threshold state returned to normal.",
    "text22": "The threshold was exceeded.",
    "text23": "AI detection event",
    "meterConditionDisabled": "Threshold events are disabled"
  },
  "viewerAiSettingsMenuLayout": {
    "text": "Up to {{limit}} detections can be registered. To add a new one, stop an existing detection.",
    "text2": "Not available"
  }
}
